import { Checkbox as AntdCheckbox } from 'antd';

const Checkbox = ({ children, className = '', ...props }) => {
    return (
        <AntdCheckbox className={`customAntdCheckbox ${className}`} {...props}>
            {children}
        </AntdCheckbox>
    );
};

Checkbox.Group = AntdCheckbox.Group;

export default Checkbox;
